import styled from 'styled-components';

type TabProps = {
  $active: boolean;
};
export const Content = styled.div`
  display: flex;
`;
export const Tab = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;
  cursor: pointer;
`;
export const Label = styled.div<TabProps>`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  margin-bottom: 16px;
  align-items: center;
  text-align: center;
  color: ${({ $active }) => ($active ? '#332927' : '#706967')};
  display: flex;
  cursor: pointer;
`;
export const Line = styled.div<TabProps>`
  width: 100%;
  height: 4px;
  background: ${({ $active }) => ($active ? '#332927' : '#EFECE9')};
  border-radius: 4px 4px 0px 0px;
`;
